import type { StoryGridSettings, ToolTaskType } from '@/app/types';

const TOOL_TASK_TYPES_WITH_TEXT_PROMPT = [
  'remake',
  'one_click',
  'music_video',
  'lip_sync',
  'tts',
  'style_transfer',
  'character_creation',
] as const satisfies readonly ToolTaskType[];

export const KEEP_CONTINUE_CREATE_PROMPT_STORAGE_KEY = 'VIDU_KEEP_CONTINUE_CREATE_PROMPT';

export const toolTaskSupportsTextPrompt = (taskType: string): boolean => {
  return (TOOL_TASK_TYPES_WITH_TEXT_PROMPT as readonly string[]).includes(taskType);
};

export const STORY_GRID_SETTINGS_OPTIONS = {
  grid_count: [4, 6, 9, 12, 16],
  duration: [8, 9, 10, 11, 12, 13, 14, 15],
  resolution: ['1080p', '2k', '4k'],
  aspect_ratio: ['16:9', '9:16', '1:1', '4:3', '3:4'],
} as const;

export const DEFAULT_STORY_GRID_SETTINGS = {
  grid_count: 9,
  duration: 9,
  resolution: '1080p',
  aspect_ratio: '16:9',
} as const satisfies Required<StoryGridSettings>;

export const STORY_GRID_MAX_REFERENCE_COUNT = 9;

const normalizeStoryGridOption = <T extends string | number>(value: unknown, options: readonly T[], fallback: T): T => {
  return options.some((option) => option === value) ? (value as T) : fallback;
};

export const normalizeStoryGridSettings = (settings?: StoryGridSettings): Required<StoryGridSettings> => ({
  grid_count: normalizeStoryGridOption(
    settings?.grid_count,
    STORY_GRID_SETTINGS_OPTIONS.grid_count,
    DEFAULT_STORY_GRID_SETTINGS.grid_count,
  ),
  duration: normalizeStoryGridOption(
    settings?.duration,
    STORY_GRID_SETTINGS_OPTIONS.duration,
    DEFAULT_STORY_GRID_SETTINGS.duration,
  ),
  resolution: normalizeStoryGridOption(
    settings?.resolution,
    STORY_GRID_SETTINGS_OPTIONS.resolution,
    DEFAULT_STORY_GRID_SETTINGS.resolution,
  ),
  aspect_ratio: normalizeStoryGridOption(
    settings?.aspect_ratio,
    STORY_GRID_SETTINGS_OPTIONS.aspect_ratio,
    DEFAULT_STORY_GRID_SETTINGS.aspect_ratio,
  ),
});
